module.exports = __webpack_public_path__ + "img/윈드워커 (2).9232e20e.png";